import { useEffect, useState } from 'react';

/**
 * Hook to detect if the component has been hydrated on the client side.
 * This helps prevent SSR/client hydration mismatches by providing a consistent
 * state during SSR and allowing components to adapt after hydration.
 */
export const useHydration = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
};
